import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  CreateProcurementsPageHeader,
  CreateProcurementsForm,
} from "./components";
import { ErrorModal, SuccessModal } from "@components";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import { ROUTES } from "@constants/routes";

const CreateProcurements = ({
  detailsView,
  procurementData,
}: {
  detailsView?: boolean;
  procurementData?: any;
}) => {
  const [procurementType, setProcurementType] = useState<string>("");

  const { procurementsState } = procurementData || {};
  const { getSingleData } = procurementsState || {};

  const navigate = useNavigate();

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { createSuccess, createError } = useCustomSelector(
    (store) => store.inventory.procurementsState,
  );

  const createSuccessAction = () => {
    navigate(`${ROUTES.INVENTORY.PROCUREMENTS}`);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (createSuccess) {
      setIsSuccessModalOpen(true);
    }
    if (createError) {
      setIsErrorModalOpen(true);
    }
  }, [createSuccess, createError]);

  useEffect(() => {
    const procuremtnTab = localStorage.getItem("procurementType");
    setProcurementType(procuremtnTab || "");
  }, []);

  return (
    <div className="p-10">
      {!detailsView && <CreateProcurementsPageHeader />}
      <CreateProcurementsForm
        procurement={getSingleData}
        detailsView={detailsView}
        procurementType={procurementType}
      />

      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
          subtitle="You have added a new procurement"
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </div>
  );
};

export default CreateProcurements;
